// Validation SIRET côté client (miroir de systems/api/src/utils/validation/siret.ts).
// 14 chiffres + clé de Luhn, avec l'exception La Poste (356000000..., somme des chiffres % 5 === 0).

export function normalizeSiret(input: string | null | undefined): string {
    return (input ?? '').replace(/\D/g, '');
}

function luhnValid(digits: string): boolean {
    let sum = 0;
    for (let i = 0; i < digits.length; i++) {
        const isSecond = (digits.length - i) % 2 === 0;
        let value = Number(digits[i]);
        if (isSecond) {
            value *= 2;
            if (value > 9) {
                value -= 9;
            }
        }
        sum += value;
    }
    return sum % 10 === 0;
}

export function isValidSiret(input: string | null | undefined): boolean {
    const siret = normalizeSiret(input);
    if (siret.length !== 14) {
        return false;
    }
    if (siret.startsWith('356000000')) {
        return [...siret].reduce((sum, digit) => sum + Number(digit), 0) % 5 === 0;
    }
    return luhnValid(siret);
}
